import axios from '@/axios/'

export default {
  namespaced: true,
  state: {
    token: undefined,
    user: undefined,
  },
  actions:{
    // 認証トークン発行
    getToken(){
      return axios.get('/GetAuthToken/1.0/')
    },
    // 認証トークン発行
    getTokenForRecive(store, param){
      return axios.post('GetAuthTokenForTicketRecive/1.0/', param)
    },
    // Jチケユーザ情報取得
    getUserInfo(store, param){
      return axios.post('/GetTktUserInfo/1.0/', param)
    },
    // ログアウト処理
    logout(store, param){
      return axios.post('/Logout/1.0/', param)
    },
    // 認証トークン発行（ログイン確認用）
    getTokenForLoginCheck(store, param){
      return axios.post('GetAuthTokenForLoginCheck/1.0/', param)
    }
  },
  mutations:{
    saveToken(state, token){
      state.token = token
    },
    saveUser(state, user){
      state.user = user
    },
    clear(state){
      state.token = undefined
      state.user = undefined
    }
  }
}